
/* injects from baggage-loader */

export const answers = [
    {
        type: 'top',
        value: undefined,
        error: false,
        text: '...andou pra <b>cima</b>?'
    },
    {
        type: 'bottom',
        value: undefined,
        error: false,
        text: '...andou pra <b>baixo</b>?'
    },
    {
        type: 'left',
        value: undefined,
        error: false,
        text: '...andou pra <b>esquerda</b>?'
    },
    {
        type: 'right',
        value: undefined,
        error: false,
        text: '...andou pra <b>direita</b>?'
    }
];

export const successText = [
    'Mas preciso que você me ajude com mais um <b>desafio</b>. Há muito <b>lixo</b> espalhado pelo <b>trajeto</b> e, para <b>retirá-lo</b> precisamos <b>identificar</b> onde ele está.',
    'Para isso, vamos <b>investigar</b> agora todos os <b>passos</b> que o tamanduá deu até o <b>formigueiro</b>.'
]
export const failText = 'Parece que você se <b>confundiu</b>. <br> Tente <b>conferir</b> novamente as respostas <b>indicadas</b> em vermelho!'



// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-tamandua/quiz-tamandua.const.js